const APPROVED = 'approved';

export { APPROVED };
